import React from 'react';

import { Tabs } from 'antd';

import { useIntl } from 'react-intl';

// PROPTYPES
import PropTypes from 'prop-types';
import { DownloadTourGpsProps } from '../../PropType/propTypesDownloadTourGps';
import { RouterProps } from '../../PropType/propTypesRouter';

import './downloadGps.css';
import '../HeaderNavBar/navbar.css';

import NotInstalledTTView from './components/notInstallTTView';
import MoreOptionView from './components/moreOptionView';
import Question from './components/question';
import Settings from './components/settings';
import DownloadGpsTabs from './downloadGpsTabs/downloadGpsTabs';

import CloseButton from '../../Utility/closeButton';

const { TabPane } = Tabs;

const handlClickClose = ({ closeDownloadGps }) => {
  closeDownloadGps(false);
};

export const DownloadGps = (props) => {
  const intl = useIntl();
  const textTransfer = intl.formatMessage({
    id: 'Transfer',
    defaultMessage: 'Transfer',
  });
  const textInstall = intl.formatMessage({
    id: 'Install',
    defaultMessage: 'Install',
  });
  const handleChange = (key) => {
    props.changeActiveTabKey(key);
  };

  return (
    <div className="dropDownDownload">
      <div className="logoDownload">
        <div className="content">
          <div className="settings">
            <span onClick={props.showFAQ} aria-hidden>
              FAQ
            </span>
            <Question />
            <Settings showLegal={props.showLegal} />
            <div onClick={() => handlClickClose(props)} aria-hidden>
              <CloseButton />
            </div>
          </div>
        </div>
      </div>

      <Tabs
        activeKey={props.activeTabKey}
        onChange={handleChange}
        type="card"
        className="main-transfer-tabs"
      >
        <TabPane
          tab={textTransfer}
          key="transfer"
          disabled={props.isNeedUpdateExistedTT}
        >
          <div className="tourDownloadLists">
            <div style={{ width: '100%', height: '100%' }}>
              <DownloadGpsTabs {...props} />
            </div>
          </div>
          <MoreOptionView {...props} />
        </TabPane>
        <TabPane
          tab={textInstall}
          key="install"
          className="install-transfer-tab"
        >
          <NotInstalledTTView {...props} />
        </TabPane>
      </Tabs>
    </div>
  );
};

DownloadGps.displayName = 'DownloadGps';

DownloadGps.propTypes = {
  TTInstalled: PropTypes.bool,
  TourBasketDataDelete: PropTypes.func,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  openTourDownloadBasket: PropTypes.func,
  router: PropTypes.shape(RouterProps),
};
